import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Scale, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import { SignaturePad } from "./SignaturePad";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";

const Reply = ({ s, onDone }) => {
  const pad = useRef(null);
  const [txt, setTxt] = useState("");
  const send = async () => {
    const signature = pad.current?.getSignature();
    if (!txt.trim() || !signature) { toast.error("اكتب إفادتك ووقّع في المربع"); return; }
    try { await api.portalSummonsReply(s.case_id, s.id, { statement: txt, signature }); toast.success("تم إرسال إفادتك"); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الإرسال"); }
  };
  return (
    <div className="mt-2 space-y-2">
      <Textarea value={txt} onChange={(e) => setTxt(e.target.value)} rows={4} placeholder="اكتب إفادتك بالتفصيل…" data-testid={`portal-summons-text-${s.id}`} />
      <SignaturePad ref={pad} height={130} />
      <Button onClick={send} className="w-full bg-[#0f1f3d]" data-testid={`portal-summons-send-${s.id}`}>إرسال الإفادة والتوقيع</Button>
    </div>
  );
};

export const PortalLegalSummons = () => {
  const [items, setItems] = useState([]);
  const load = () => api.portalSummons().then((r) => setItems(r.items || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!items.length) return null;
  return (
    <div className="mb-4 space-y-2" data-testid="portal-legal-summons">
      <h3 className="flex items-center gap-1.5 font-heading font-bold text-slate-800"><Scale className="h-4 w-4 text-amber-600" /> استدعاءات قانونية</h3>
      {items.map((s) => (
        <div key={s.id} className="rounded-2xl border border-amber-200 bg-amber-50/60 p-3" data-testid={`portal-summons-${s.id}`}>
          <p className="text-sm font-bold">{s.title} <span className="font-mono text-xs text-slate-500" dir="ltr">{s.number}</span></p>
          <p className="text-xs text-slate-600">صفتك: {s.role}{s.date ? ` · الموعد: ${s.date.replace("T", " ")}` : ""}{s.note ? ` · ${s.note}` : ""}</p>
          {s.status === "responded" ? <p className="mt-2 flex items-center gap-1 text-xs font-bold text-emerald-700"><CheckCircle2 className="h-4 w-4" /> أرسلت إفادتك: «{s.statement}»</p>
            : s.case_status !== "closed" && <Reply s={s} onDone={load} />}
        </div>
      ))}
    </div>
  );
};
